module.exports = __webpack_public_path__ + "static/img/4en.3902999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/4en.png
// module id = kUO3
// module chunks = 0